<div class="component-container flex flex-col justify-center items-center">
  <div class="heading mb-[3rem]">
    Assign Participant to Group
  </div>
  <div class="details w-full flex flex-col justify-start items-center gap-[2rem]">
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/2">
        Participant Name :
      </div>
      <div class="value w-full sm:w-1/2">
        {{ participantName || 'NA' }}
      </div>
    </div>
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/2">
        Current Group :
      </div>
      <div class="value w-full sm:w-1/2">
        {{ currentParticipantGroupName || 'NA' }}
      </div>
    </div>
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/2">
        Current Group Status :
      </div>
      <div class="value w-full sm:w-1/2">
        {{ currentParticipantGroupStatus || 'NA' }}
      </div>
    </div>
    <div class="flex-col sm:flex-row w-full flex justify-start items-center gap-[1.5rem]">
      <div class="label w-full sm:w-1/3 sm:mb-[2rem]">
        Assign Participant to Group :
      </div>
      <app-search-on-select (checkForErrors)="checkForErrors($event)" (onNextPage)="groupsOnNextPage()"
        [error]="errorMessages['group']" [hasNext]="groupFilterList.hasNext" [loading]="groupFilterList.loading"
        [options]="groupFilterList.list" [parentFormGroup]="form" class="value w-full sm:w-1/2" controlName="group"
        filterControlName="searchGroup" optionsPanelClassName="groups-dropdown" placeholder="Select all that apply"
        type="small">
      </app-search-on-select>
    </div>
  </div>
  <div class="action-section flex flex-row
           justify-end items-center w-full">
    <app-primary-button (handleClick)="save()" [isDisabled]="!form.dirty"
      [isLoading]="loading" class="save-btn w-[15rem]" type="small">
      Save
    </app-primary-button>
  </div>
</div>